var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({staticClass:"outline-primary",attrs:{"outlined":""},nativeOn:{"click":function($event){return _vm.followButton.apply(null, arguments)}}},'v-btn',_vm.attributes,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }